$(document).on('click', '.size-conversions button', function (e) {
  if ($(this).hasClass('conversion')) {
    $(this).closest('.product-info').attr('converted', '');
  } else {
    $(this).closest('.product-info').removeAttr('converted');
  }
});
$(document).ready(function() {
  $('.product-info').attr('converted', '');
});
$(document).on('click', '.product-card .variant-picker .thumbnail-swatch', function (e) {
  e.preventDefault();
  e.stopPropagation()

  $(this).siblings('.thumbnail-swatch').removeClass('is-selected');
  $(this).addClass('is-selected');

  if ($(this).data('swatch-product-image')) {
    let main_image = $(this).parents('.product-card').find('.product-card__image--primary');
    let alt_image = $(this).parents('.product-card').find('.product-card__image--secondary');

    var newImageElement = document.createElement('img');
    newImageElement.className = 'product-card__image product-card__image--primary  aspect-square';
    newImageElement.setAttribute('width', '1000px');
    newImageElement.setAttribute('height', '1000px');
    newImageElement.setAttribute('src', $(this).data('swatch-product-image'));

    if ($(this).data('swatch-product-alt-image')) {
      var newAltImageElement = document.createElement('img');
      newAltImageElement.className = 'product-card__image product-card__image--secondary';
      newAltImageElement.setAttribute('src', $(this).data('swatch-product-alt-image'));
      
      $(main_image).replaceWith(newImageElement);
      $(alt_image).replaceWith(newAltImageElement);
    } else {
      var newAltImageElement = document.createElement('img');
      newAltImageElement.className = 'product-card__image product-card__image--secondary';
      newAltImageElement.setAttribute('src', $(this).data('swatch-product-image'));
      
      $(main_image).replaceWith(newImageElement);
      $(alt_image).replaceWith(newAltImageElement);
    }

  }
  var productItem = this.closest('.product-card');
  var variantHandle = $(this).data("variant-handle");
  var variantUrl = $(this).data("variant-url");
  var variantTitle = $(this).data("variant-title");
  var variantPrice = $(this).data("variant-price");
  var variantComparePrice = $(this).data("variant-compare-price");
  var variantFullPrice = $(this).data("variant-full-price");
  var variantAvailable = $(this).data("variant-available");
  var swatchProductQuickBuy = $(this).data("swatch-product-quickbuy");

  if (variantFullPrice == "true") {
    productItem.classList.remove("Sale");
    productItem.classList.add("Full");
  } else {
    productItem.classList.remove("Full");
    productItem.classList.add("Sale");
  }
  if (variantAvailable == "true") {
    productItem.classList.remove("Sold-Out");
    productItem.classList.add("Available");
  } else {
    productItem.classList.remove("Available");
    productItem.classList.add("Sold-Out");
  }
  productItem.setAttribute('handle', variantHandle);
  productItem.querySelector('.product-card__figure .product-card__media').setAttribute('href', variantUrl);
  productItem.querySelector('.product-card__info .product-title').innerHTML = variantTitle;
  productItem.querySelector('.product-card__info sale-price').innerHTML = variantPrice;
  productItem.querySelector('.product-card__info compare-at-price').innerHTML = variantComparePrice;
  productItem.querySelector('.product-card__quick-buy button').setAttribute('aria-controls', swatchProductQuickBuy);
  console.log(variantHandle);
    
});

$(document).on('click', '.product-card__variations .swatch-products-more', function () {
  $(this).remove();
});
// -----------------------------------------------
// Prevent auto-selected size on PDP
// -----------------------------------------------
$(document).ready(function() {
  $('fieldset[data-option-name="size"] input[type="radio"]').prop('checked', false);
  $('form[action*="/cart/add"] input[name="id"]').val('');
});

$(document).on('click', 'form[action*="/cart/add"] [type="submit"]', function(e) {
  if ($('fieldset[data-option-name="size"] input[type="radio"]:checked').length === 0) {
    e.preventDefault();
    if ($('.size-required-msg').length === 0) {
      $('fieldset[data-option-name="size"]').after('<p class="size-required-msg" style="color:red; font-size:0.85rem; margin-top:0.5rem;">Please select a size.</p>');
    }
    return false;
  }
});

$(document).on('change', 'fieldset[data-option-name="size"] input[type="radio"]', function() {
  $('.size-required-msg').remove();
});
// -----------------------------------------------
// PDP color swatches - replace history to prevent
// back-button stacking across color PDPs
// -----------------------------------------------
$(document).on('click', '.product-info a.thumbnail-swatch', function(e) {
  e.preventDefault();
  window.location.replace($(this).attr('href'));
});
// -----------------------------------------------
// ADA Fix: Menu Drawer Focus Management
// -----------------------------------------------
(function() {
  function initMenuDrawerAccessibility() {
    var menuDrawer = document.querySelector('header-menu-drawer');
    if (!menuDrawer) return;

    menuDrawer.setAttribute('aria-modal', 'true');

    function setInertState(isOpen) {
      document.querySelectorAll('body > *').forEach(function(el) {
        if (el === menuDrawer || el.contains(menuDrawer)) return;
        if (isOpen) {
          if (!el.hasAttribute('inert')) {
            el.setAttribute('inert', '');
            el.setAttribute('data-inert-added', '');
          }
        } else {
          if (el.hasAttribute('data-inert-added')) {
            el.removeAttribute('inert');
            el.removeAttribute('data-inert-added');
          }
        }
      });
    }

    // When drawer opens, inert everything outside and move focus in
    menuDrawer.addEventListener('dialog:before-show', function() {
      setInertState(true);
      setTimeout(function() {
        var mainPanel = menuDrawer.querySelector('#menu-drawer-panel-main');
        if (mainPanel) {
          var firstFocusable = mainPanel.querySelector('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
          if (firstFocusable) firstFocusable.focus();
        }
      }, 400);
    });

    // When drawer closes, remove inert from everything
    menuDrawer.addEventListener('dialog:after-hide', function() {
      setInertState(false);
    });

    // When switching panels, move focus to first item in new panel
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          var panel = mutation.target;
          if (panel.tagName.toLowerCase() === 'header-menu-drawer-panel' &&
              panel.classList.contains('is-visible') &&
              !(mutation.oldValue && mutation.oldValue.includes('is-visible'))) {
            setTimeout(function() {
              var firstFocusable = panel.querySelector('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
              if (firstFocusable) firstFocusable.focus();
            }, 300);
          }
        }
      });
    });

    menuDrawer.querySelectorAll('header-menu-drawer-panel').forEach(function(panel) {
      observer.observe(panel, {
        attributes: true,
        attributeFilter: ['class'],
        attributeOldValue: true
      });
    });

    // Trap focus within drawer for keyboard users
    menuDrawer.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab' || !menuDrawer.hasAttribute('open')) return;
      var visibleFocusable = Array.from(menuDrawer.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function(el) { return el.offsetParent !== null; });
      if (visibleFocusable.length === 0) return;
      var first = visibleFocusable[0];
      var last = visibleFocusable[visibleFocusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        last.focus();
        e.preventDefault();
      } else if (!e.shiftKey && document.activeElement === last) {
        first.focus();
        e.preventDefault();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuDrawerAccessibility);
  } else {
    initMenuDrawerAccessibility();
  }
})();
// -----------------------------------------------
// ADA Fix: Filter Drawer Focus Management
// -----------------------------------------------
(function() {
  function initFacetsDrawerAccessibility() {
    var facetsDrawer = document.querySelector('facets-drawer');
    if (!facetsDrawer) return;

    function setFacetsInertState(isOpen) {
      if (isOpen) {
        document.querySelectorAll('body > *').forEach(function(el) {
          if (el === facetsDrawer || el.contains(facetsDrawer)) return;
          if (!el.hasAttribute('inert')) {
            el.setAttribute('inert', '');
            el.setAttribute('data-facets-inert-added', '');
          }
        });
      } else {
        document.querySelectorAll('[data-facets-inert-added]').forEach(function(el) {
          el.removeAttribute('inert');
          el.removeAttribute('data-facets-inert-added');
        });
      }
    }

    function getVisibleTrigger() {
      var buttons = document.querySelectorAll('button[aria-controls="facets-drawer"]');
      return Array.from(buttons).find(function(btn) {
        return btn.offsetParent !== null;
      });
    }

var openObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.attributeName !== 'open') return;
    if (facetsDrawer.hasAttribute('open')) {
      setTimeout(function() {
        if (!facetsDrawer.hasAttribute('open')) return; // Guard: abort if already closed
        setFacetsInertState(true);
      }, 50);
    } else {
      setFacetsInertState(false);
      setTimeout(function() {
        var trigger = getVisibleTrigger();
        if (trigger) trigger.focus();
      }, 150);
    }
  });
});

    openObserver.observe(facetsDrawer, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFacetsDrawerAccessibility);
  } else {
    initFacetsDrawerAccessibility();
  }
})();
// View More — collection pages
(function () {
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-view-more-btn]');
    if (!btn) return;

    const wrapper = btn.closest('[data-view-more-wrapper]');
    const grid = document.querySelector('[data-collection-product-grid]');
    if (!grid) return;

    const nextUrl = btn.getAttribute('data-next-url');
    if (!nextUrl) return;

    btn.disabled = true;
    btn.textContent = 'Loading...';

    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('[data-collection-product-grid]');

      if (newGrid) {
        const existingList = grid.querySelector('ul');
        const newList = newGrid.querySelector('ul');

        if (existingList && newList) {
          Array.from(newList.children).forEach(function (item) {
            existingList.appendChild(document.adoptNode(item));
          });
        } else {
          grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
        }
      }

      const newBtn = doc.querySelector('[data-view-more-btn]');
      if (newBtn) {
        btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
        btn.disabled = false;
        btn.textContent = 'View More';
      } else {
        if (wrapper) wrapper.remove();
      }

    } catch (err) {
      console.error('View More failed:', err);
      btn.disabled = false;
      btn.textContent = 'View More';
    }
  });
})();